import { gql } from '@apollo/client';
import { TEST_SESSION_ANSWER_FRAGMENT, TEST_SESSION_SPEAKER_FRAGMENT, TESTER_RATING_FRAGMENT } from '../../../core/graphql/test-sessions';

const GET_PROJECT_TESTERS = gql`
  query Project($id: ID!) {
    project(id: $id) {
      id
      testers {
        id
        approved
        testSessions {
          id
          videoKey
          videoUrl
          status
          approved
          removed
          ...TesterRating
          transcriptText {
            text
            speakerTag
            startTime
          }
          testSessionAnswers {
            ...TestSessionAnswerFields
          }
          testSessionSpeakers {
            ...TestSessionSpeakerFields
          }
          deviceType
          osType
          osVersion
          deviceInfo {
            retailBrand
            marketingName
          }
          practiceTestStatus
        }
        user {
          id
          guest
          profile {
            id
            firstName
            lastName
            linkedinFields {
              emailAddress
              educationLevel
              linkedinUrl
              currentPosition {
                title
                description
                seniority
                company {
                  name
                  size
                  industry
                }
                startDate {
                  year
                  month
                }
                endDate {
                  year
                  month
                }
              }
            }
            email
            birthdate
            gender
            raceEthnicHeritage
            annualHouseholdIncome
            otherDevices
            country
            state
            jobCategories {
              name
            }
          }
        }
        screenerSession {
          id
          screenerSessionAnswers {
            id
            questionId
            questionOptionId
          }
        }
      }
    }
  }
  ${TESTER_RATING_FRAGMENT}
  ${TEST_SESSION_ANSWER_FRAGMENT}
  ${TEST_SESSION_SPEAKER_FRAGMENT}
`;

export default GET_PROJECT_TESTERS;
